import { render, staticRenderFns } from "./FormLeaseTermsSummary.vue?vue&type=template&id=2a05177c&"
import script from "./FormLeaseTermsSummary.vue?vue&type=script&lang=js&"
export * from "./FormLeaseTermsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports